import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IWorkspaceInstanceModel } from '../../../../models/workspace/workspace-instance.model';
import { NodeInstanceModel } from '../../../../models/node/node-instance.model';

@Component({
  selector: 'app-edit-panel-comments-pane',
  templateUrl: './edit-panel-comments-pane.component.html',
  styleUrls: ['./edit-panel-comments-pane.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EditPanelCommentsPaneComponent {
  @Input() commentsCount = 0;
  @Input() selectedWorkspace?: IWorkspaceInstanceModel | null;
  @Input() selectedWorkspaceInstanceNode?: NodeInstanceModel | null;
}
